import { QueryClient } from 'react-query';

import { isServerError } from 'core/api';

const RETRY_TIMES = 3;

export const appQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: (failureCount, error) => isServerError(error) && failureCount < RETRY_TIMES
    }
  }
});
